export default __webpack_public_path__ + "static/media/alimentacao.d79e02a2.png";